var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 63c-1 34-16 32-34 32-9 0-19-2-25-7-5-5-8-13-8-25 0-7 3-16 9-22 8-10 21-17 24-10 26 16 35-5 34 32ZM77 15c1 11-4 9-7 9-10 1-10-1-9-8 0-10-1-17 9-14 9 3 7 10 7 13Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30c-2 20-7 5-11 3s-41 25-8-10c9-9 7-36 14-6 11-13 11-2 5 13Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5 45 25-1v6l-2 3-2 4v12l1 5 1 5 2 5 4 4v4H10l-4-3-2-3-2-5-1-9V56l1-6 3-5Z",
    fill: "#fff",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.218cb0eea6ad08cca93d9e0ba48c6b8f.svg";
export { ForwardRef as ReactComponent };